import {
  ACCESS_TOKEN,
  KEY_SHIPPING_INFO,
  USER_INFO,
  WISHES_LIST,
} from "../common/constant";
import { IProfile } from "../models/profileModel";
import IShippingInfo from "../models/shippingInfoModel";
import { products, user } from "../repositories";
import { profile } from "../repositories/";
import { updateShippingInfo } from "./shoppingCart";

export const getShippingInfo = () => {
  const data = localStorage.getItem(KEY_SHIPPING_INFO);
  let lstShipping: IShippingInfo[] = data ? JSON.parse(data) : null;
  return lstShipping;
};

export const saveShippingInfo = (shippingInfoList: IShippingInfo[]) => {
  localStorage.setItem(KEY_SHIPPING_INFO, JSON.stringify(shippingInfoList));
};

export const getUserInfoLocal = () => {
  const data = localStorage.getItem(USER_INFO);
  let profile: IProfile = data ? JSON.parse(data) : null;
  return profile;
};

export const saveWishesListLocal = (data: any[]) => {
  localStorage.setItem(WISHES_LIST, JSON.stringify(data));
};

export const cleanWishesListLocal = () => {
  localStorage.setItem(WISHES_LIST, "");
};

export const saveUserInfoLocal = (data: IProfile) => {
  localStorage.setItem(USER_INFO, JSON.stringify(data));
};

export const cleanUserInfo = () => {
  localStorage.setItem(USER_INFO, "");
};

export const getAccessToken = () => {
  const token = localStorage.getItem(ACCESS_TOKEN);
  return token;
};

export const loadData = async () => {
  const token = localStorage.getItem(ACCESS_TOKEN);

  if (token) {
    const data = await Promise.all([
      profile.profileGetInfo().catch(() => {
        cleanDataUser()
      }),
      user.getDeliveries(),
      products.getProductsWishV2({ offset: 0, limit: 1000 }),
    ]);

    return {
      userInfo: data[0]?.data,
      deliveries: data[1]?.data?.docs,
      wishesList: data[2]?.data?.docs,
    };
  }
  return {
    userInfo: null,
    deliveries: null,
    wishesList: null,
  };
};

export const addOrUpdateShippingInfo = async (info: IShippingInfo) => {
  let shippingInfoList: IShippingInfo[] = getShippingInfo();
  let token = getAccessToken();
  // info.full_name_recevied = `${info.first_name} ${info.last_name}`;
  let data: IShippingInfo | null = null;
  if (token) {
    if (info._id) {
      const rs = await profile.updateShippingDeliveryInfo(info._id, info);
      if (rs && rs.status == 200) {
        data = info;
      }
    } else {
      const rs = await profile.createShippingDeliveryInfo(info);
      if (rs && rs.status == 200 && rs.data) {
        data = { ...rs.data, note: info?.note || "" };
      }
    }
  }

  if (!shippingInfoList) {
    shippingInfoList = [];
  }
  if (!data) {
    data = info;
  }
  // debugger
  let index = shippingInfoList.findIndex((x) => x._id == data?._id);
  if (index >= 0) {
    shippingInfoList[index] = data;
  } else {
    shippingInfoList.push(data);
  }

  updateShippingInfo(data);
  saveShippingInfo(shippingInfoList);
  return shippingInfoList;
};

const cleanDataUser = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(USER_INFO);
  cleanWishesListLocal();
}

export default {
  getUserInfoLocal,
  profileGetInfo: async (callback: (data: any, err: any) => void) => {
    try {
      const rs = await profile.profileGetInfo();
      callback(rs.data, null);
    } catch (error) {
      cleanDataUser()
      let empty: any = null;
      callback(empty, error);
    }
  },
  profileUpdateInfo: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await profile.profileUpdateInfo(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  profileChangePassword: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await profile.profileChangePassword(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
  getPointHistories: async (
    query: any,
    callback: (data: any, err: any) => void
  ) => {
    try {
      const rs = await profile.getPointHistories(query);
      callback(rs.data, null);
    } catch (error) {
      let empty: any = null;
      callback(empty, error);
    }
  },
};
